//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export interface AdminMaintenanceMessageModel {
    maintenanceMessageId: number;
    startDTG: string | null;
    endDTG: string | null;
    message: string | null;
    messageType: MaintenanceMessageType | null;
    ticketNumber: string | null;
    companies: AdminMaintenanceMessageCompany[] | null;
}

export enum MaintenanceMessageType {
    Scheduled = 0,
    Completed = 1,
    Deleted = 2,
}

export interface AdminMaintenanceMessageCompany {
    companyId: number;
    companyName: string | null;
}

export interface MaintenanceMessageIdentity {
    id: number;
}

export interface AdminNotificationHeader {
    notificationId: number;
    registration: string | null;
    mainReference: string | null;
    secondReference: string | null;
    repairerName: string | null;
    currentRepair: string | null;
    notificationDate: string | null;
    workProvider: string | null;
}

export interface NotificationDetail {
    fnol: NotificationDetailFNOL | null;
    repair: NotificationDetailRepairOverview | null;
    updates: NotificationDetailQueue[] | null;
}

export interface NotificationDetailFNOL {
    id: number;
    registration: string | null;
    mainReference: string | null;
    secondReference: string | null;
    receivedDate: string | null;
    readDate: string | null;
    sender: string | null;
    recipient: string | null;
}

export interface NotificationDetailRepairOverview {
    repairId: number;
    vehicleReg: string | null;
    schemeCode: string | null;
    claimReference: string | null;
    repairer: string | null;
    repairCode: string | null;
    lastUpdatedDTG: string | null;
}

export interface NotificationDetailQueue {
    id: number;
    queue: QueueType | null;
    messageType: string | null;
    receivedDate: string | null;
    readDate: string | null;
    sender: string | null;
    recipient: string | null;
    messageContent: string | null;
}

export enum QueueType {
    Wcf = 0,
    WcfHistory = 1,
    Rest = 2,
    RestHistory = 3,
    PoisonQueue = 4,
    CAPSInbound = 5,
    CAPSInboundHistory = 6,
    CAPSInboundPoison = 7,
}

export interface AdminJobStatusUpdateResponse {
    activeWebID: string | null;
    isUpdated: boolean;
}

export interface AdminJobStatusUpdateModel {
    activeWebID: string | null;
    comment: string | null;
    status: AdminJobUpdateStatus;
    ticketNumber: string | null;
}

export enum AdminJobUpdateStatus {
    Finished = 14,
    Cancelled = 15,
    TotalLoss = 16,
}

export interface AdminWPNameChangeResponse {
    activeWebID: string | null;
    isUpdated: boolean;
}

export interface AdminWPNameChangeModel {
    activeWebID: string | null;
    comment: string | null;
    schemeCode: string | null;
    ticketNumber: string | null;
}

export interface RepairerSearchModel {
    repairerId: number;
    repairerName: string | null;
    siteCode: string | null;
    status: string | null;
}

export interface AdminLockRepairerModel {
    repairerId: number;
    ticketId: string | null;
    comment: string | null;
}

export interface CreateRepairerResponse {
    id: number | null;
    isSuccess: boolean;
    message: string | null;
}

export interface AdminRepairerModel {
    repairerId: number;
    name: string | null;
    address: string | null;
    postCode: string | null;
    siteCode: string | null;
    repairerGroup: string | null;
    accountLive: boolean;
    telephone: string | null;
    fax: string | null;
    email: string | null;
    website: string | null;
    systemType: string | null;
    linkType: RepairerLinkType;
    vatRegistrationNo: string | null;
    ticketId: string | null;
    comment: string | null;
    capsCode: string | null;
    coveaCode: string | null;
    audatexCode: string | null;
    companyId: number;
}

export enum RepairerLinkType {
    Advance = 0,
    CAPS = 1,
    ADR = 2,
    BSD = 3,
    Generic = 4,
    Advance7 = 5,
    Nationwide = 6,
    BMS = 7,
    NARG = 8,
    CAPSv3 = 9,
    ITAS = 10,
    None = -1,
}

export interface AdminRepairerConnectionSettingModel {
    workProviderID: number;
    workProviderName: string | null;
    requireExternalCode: boolean;
    fnolConfiguration: AdminRepairerConnectionFNOLConfiguration[] | null;
    b2BSetting: AdminRepairerConnectionB2BSetting[] | null;
    smsSubscription: AdminRepairerConnectionSMSSubscription[] | null;
    userPermit: AdminRepairerConnectionUserPermit[] | null;
}

export interface AdminRepairerConnectionFNOLConfiguration {
    workProvider: string | null;
    externalSourceID: number;
    externalSourceStream: string | null;
    externalSourceRepairerID: string | null;
    sourceRepairer: string | null;
    sourceRepairerCode: string | null;
    deployToRepairer: string | null;
    deployToSiteCode: string | null;
    streamCodeToUse: string | null;
    deployElectronically: boolean;
    deploymentMethod: number;
    deployByEmail: boolean;
    deployToEmail: string | null;
    customSettings: string | null;
}

export interface AdminRepairerConnectionB2BSetting {
    b2BFormat: string | null;
    wpId: string | null;
    b2BCustomSetting: string | null;
    userProfile: string | null;
    serviceStartDate: string;
}

export interface AdminRepairerConnectionSMSSubscription {
    startDate: string;
    wpId: string | null;
    processor: SMSProcessors;
}

export enum SMSProcessors {
    Allianz = 1,
    Zurich = 41,
    Covea = 61,
    DLG = 67,
    NPS = 69,
    DLGV2 = 670,
    RSA = 691,
}

export interface AdminRepairerConnectionUserPermit {
    wpId: string | null;
    dataAccessProfile: string | null;
}

export interface AdminAddRepairerConnectionModel {
    workProviderID: number;
    ticketId: string | null;
    comment: string | null;
    repairerId: number;
    externalCode: string | null;
    deploymentType: DeploymentMethod | null;
    schemeCodeOverride: string | null;
    deployToSiteCode: string | null;
    deployToEmail: string | null;
    coveaCode: string | null;
    sysType: string | null;
    externalRepairerName: string | null;
    kindertonsCode: string | null;
    fixSiteCode: string | null;
    customSettings: string | null;
    overwriteExisting: boolean | null;
    fixType: string | null;
    deploymentMethods: DeploymentConfiguration[] | null;
    serviceStartDate: string;
    manufacturer: string | null;
    isExistingConnection: boolean;
    isRequiresSecondReference: boolean;
}

export enum DeploymentMethod {
    Advance = 0,
    HAL = 4,
    Advance7 = 5,
    Voyager = 6,
    CAPSv3 = 9,
    VIZION = 13,
    CAPSv5 = 14,
    Unknown = -1,
}

export interface DeploymentConfiguration {
    managementSystem: string | null;
    deploymentMode: number;
    b2BFnolRecipientId: number | null;
}

export interface AdminRepairerDetails {
    repairerDetails: AdminRepairerBasicDetails | null;
    externalCodes: AdminRepairerExternalCode[] | null;
    updateCounts: AdminRepairerUpdateCounts[] | null;
    connections: AdminRepairerConnections[] | null;
    history: AdminRepairerConnectionHistory[] | null;
    lastUpdated: string;
}

export interface AdminRepairerBasicDetails {
    repairerName: string | null;
    repaierGroup: string | null;
    address: string | null;
    telephone: string | null;
    email: string | null;
    postcode: string | null;
    website: string | null;
    vatRegistrationNo: string | null;
    siteCode: string | null;
    systemType: string | null;
    status: string | null;
    companyId: number | null;
    accountLive: boolean;
}

export interface AdminRepairerExternalCode {
    externalSystem: string | null;
    externalCode: string | null;
    dtgCreated: string;
    enabled: boolean;
}

export interface AdminRepairerUpdateCounts {
    count: number;
    dtgUpdate: string;
}

export interface AdminRepairerConnections {
    wpMasterId: number;
    workProvider: string | null;
    userPermits: number;
    fnol: number;
    b2bSettings: number;
    sms: number;
    canAdd: boolean;
    canRemove: boolean;
}

export interface AdminRepairerConnectionHistory {
    wpName: string | null;
    username: string | null;
    description: string | null;
    action: string | null;
    dtgAction: string;
    ticketNumber: string | null;
}

export interface AdminRemoveRepairerConnectionModel {
    workProviderID: number;
    ticketId: string | null;
    comment: string | null;
    repairerId: number;
    schemeCode: string | null;
    cwCode: string | null;
}

export interface AdminTerminateRepairerModel {
    ticketId: string | null;
    comment: string | null;
    repairerId: number;
    forceRemovalFromDLG: boolean;
}

export interface AdminAddExternalConfigurationModel {
    repairerId: number;
    workProviderID: number;
    sourceRepairerCode: string | null;
    deployToSiteCode: string | null;
    externalSiteCode: string | null;
    streamCodeToUse: string | null;
    deployToEmailAddress: string | null;
    connectionType: DeploymentMethod;
}

export interface AdminReactivateRepairerModel {
    ticketId: string | null;
    comment: string | null;
    repairerId: number;
}

export interface ExternalSourceConfiguration {
    workProvider: string;
    externalSourceID: number;
    externalSourceStream: string;
    externalSourceRepairerID: string;
    sourceRepairer: string;
    sourceRepairerCode: string;
    deployToRepairer: string;
    deployToSiteCode: string;
    streamCodeToUse: string;
    deployElectronically: boolean;
    deploymentMethod: number;
    deployByEmail: boolean;
    deployToEmail: string;
    customSettings: string;
}

export interface ChangeLog {
    id: number;
    applicationId: ApplicationId;
    changeDate: string;
    changeNumber: string;
    description: string;
}

export enum ApplicationId {
    ActivewebUI = "ActivewebUI",
    ActivewebConnectionsAdminUI = "ActivewebConnectionsAdminUI",
}

export interface HelpContext {
    message: string | null;
}

function jsonParse(json: any, reviver?: any) {
    json = JSON.parse(json, reviver);

    var byid: any = {};
    var refs: any = [];
    json = (function recurse(obj: any, prop?: any, parent?: any) {
        if (typeof obj !== 'object' || !obj)
            return obj;
        
        if ("$ref" in obj) {
            let ref = obj.$ref;
            if (ref in byid)
                return byid[ref];
            refs.push([parent, prop, ref]);
            return undefined;
        } else if ("$id" in obj) {
            let id = obj.$id;
            delete obj.$id;
            if ("$values" in obj)
                obj = obj.$values;
            byid[id] = obj;
        }
        
        if (Array.isArray(obj)) {
            obj = obj.map((v, i) => recurse(v, i, obj));
        } else {
            for (var p in obj) {
                if (obj.hasOwnProperty(p) && obj[p] && typeof obj[p] === 'object')
                    obj[p] = recurse(obj[p], p, obj);
            }
        }

        return obj;
    })(json);

    for (let i = 0; i < refs.length; i++) {
        const ref = refs[i];
        ref[0][ref[1]] = byid[ref[2]];
    }

    return json;
}

function createInstance<T>(data: any, mappings: any, type: any): T | null {
  if (!mappings)
    mappings = [];
  if (!data)
    return null;

  const mappingIndexName = "__mappingIndex";
  if (data[mappingIndexName])
    return <T>mappings[data[mappingIndexName]].target;

  data[mappingIndexName] = mappings.length;

  let result: any = new type();
  mappings.push({ source: data, target: result });
  result.init(data, mappings);
  return result;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}